import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoFileUploadBaseComponent } from '../eo-file-upload-base/eo-file-upload-base.component';

@Component({
  selector: 'eo-file-upload-advanced',
  templateUrl: './eo-file-upload-advanced.component.html',
  styleUrl: './eo-file-upload-advanced.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EoFileUploadAdvancedComponent),
      multi: true,
    },
  ],
})
export class EoFileUploadAdvancedComponent extends EoFileUploadBaseComponent {
  @Input() dragAndDropSummary = 'Drag and drop files here to upload.';
  @Input() dragAndDropDescription?: string;
}
